import { toast } from "sonner";

const esc = (s) => String(s ?? "").replace(/[&<>"]/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const n = (v, d = 2) => Number(v || 0).toLocaleString("en-US", { maximumFractionDigits: d });

const table = (head, rows) => `<table><thead><tr>${head.map((h) => `<th>${esc(h)}</th>`).join("")}</tr></thead>
<tbody>${rows.map((r) => `<tr>${r.map((c) => `<td>${esc(c)}</td>`).join("")}</tr>`).join("")}</tbody></table>`;

// Printable (save-as-PDF) Waei analysis report; Arabic/RTL rendered natively by the browser.
export const printWaeiAnalysis = (d) => {
  const w = window.open("", "_blank");
  if (!w) { toast.error("اسمح بالنوافذ المنبثقة لحفظ الملف"); return; }
  const kpis = [
    ["الإجمالي شامل الضريبة", `${n(d.total)} ⃁`], ["قبل الضريبة", `${n(d.net)} ⃁`], ["الضريبة 15%", `${n(d.vat)} ⃁`],
    ["اللترات", n(d.liters)], ["سعر اللتر", `${n(d.price_per_liter, 3)} ⃁`], ["عدد اللوحات", d.plates_count],
    ["عدد التعبئات", d.tx_count || "—"], [`تعبئات > ${n(d.limit, 0)} لتر`, `${d.suspicious_count} · ${n(d.suspicious_amount)} ⃁`],
  ];
  const grp = (items, count) => table(count ? ["الاسم", "التعبئات", "المبلغ"] : ["الاسم", "اللترات", "المبلغ"],
    items.map((x) => [x.name, count ? x.count : n(x.liters), n(x.amount)]));
  w.document.write(`<!doctype html><html dir="rtl" lang="ar"><head><style>@font-face{font-family:SaudiRiyal;src:url(/fonts/riyal.woff2) format("woff2");unicode-range:U+20C1}</style><meta charset="utf-8"><title>تحليل واعي ${esc(d.month)}</title>
<style>
body{font-family:SaudiRiyal,Tahoma,Arial,sans-serif;color:#0f172a;margin:24px;font-size:12px}
h1{font-size:20px;margin:0 0 4px}h2{font-size:14px;margin:22px 0 8px;color:#047857}
.sub{color:#64748b;margin-bottom:16px}.kpis{display:grid;grid-template-columns:repeat(4,1fr);gap:8px}
.k{border:1px solid #e2e8f0;border-radius:10px;padding:10px}.k b{display:block;font-size:15px;margin-top:4px}
table{width:100%;border-collapse:collapse;margin-top:4px}th,td{border:1px solid #e2e8f0;padding:5px 7px;text-align:right}
th{background:#f1f5f9}.grid3{display:grid;grid-template-columns:repeat(3,1fr);gap:12px}
.danger h2{color:#be123c}@media print{h2{break-after:avoid}tr{break-inside:avoid}}
</style></head><body>
<h1>تحليل فاتورة واعي (الدريس)</h1>
<div class="sub">الشهر: ${esc(d.month)}${d.previous ? ` · الشهر السابق ${esc(d.previous.month)}: ${n(d.previous.total)} ⃁` : ""} · تاريخ الطباعة: ${new Date().toLocaleDateString("en-GB")}</div>
<div class="kpis">${kpis.map(([l, v]) => `<div class="k">${esc(l)}<b>${esc(v)}</b></div>`).join("")}</div>
<div class="grid3">
<div><h2>حسب نوع الوقود</h2>${grp(d.fuel_types)}</div>
<div><h2>حسب الإدارة</h2>${grp(d.departments)}</div>
<div><h2>أكثر المحطات</h2>${grp(d.stations, true)}</div>
</div>
<div class="danger"><h2>التعبئات المشبوهة (${d.suspicious_count})</h2>
${d.suspicious.length ? table(["اللوحة", "المندوب", "اللترات", "المبلغ", "المحطة"], d.suspicious.map((s) => [s.plate, s.employee_name, n(s.liters), n(s.amount), s.station])) : "<p>لا توجد</p>"}</div>
<h2>تكلفة كل لوحة (${d.top_plates.length})</h2>
${table(["#", "اللوحة", "المندوب", "التعبئات", "اللترات", "المبلغ"], d.top_plates.map((p, i) => [i + 1, p.plate, p.employee_name, p.count || "—", n(p.liters), n(p.amount)]))}
<script>window.onload=()=>setTimeout(()=>window.print(),300)</script>
</body></html>`);
  w.document.close();
};
